import * as React from 'react';
import { components } from 'react-select';

const SingleValue: React.SFC<any> = (props) => {
    // console.log("CustomContainer=====>",props);
    const FilterValue = props.selectProps.components.FilterValue;
    return (
        <components.SingleValue {...props} {...props.innerProps}>
            {props.hasValue && FilterValue ? <FilterValue /> : null}
            {props.data.image ? (
                <div className="react-select__image-box">
                    <img src={props.data.image} />
                </div>
            ) : null}
            {props.children}
        </components.SingleValue>
    );
};
export default SingleValue;
